import { ContractRuleStatus, Modal } from '../../../__generated__/api'

/**
 * Find the appropriate modal based on an appointment's OHC contract status. This logic was previously in the api.
 * @param contractRuleStatus The ContractRuleStatus value
 * @param modals Array of available modals
 * @returns The matching modal or undefined if no match is found
 */
export const findDefaultModalByOhcStatus = (
  contractRuleStatus: ContractRuleStatus | undefined,
  modals: Modal[] | undefined
): Modal | undefined => {
  const defaultModals = modals?.filter((m) => m.default)
  if (
    !contractRuleStatus ||
    !defaultModals ||
    contractRuleStatus === ContractRuleStatus.Allowed ||
    contractRuleStatus === ContractRuleStatus.BookingPermitAllowed
  ) {
    return undefined
  }

  return defaultModals.find((m) => {
    switch (contractRuleStatus) {
      case ContractRuleStatus.Restriction:
        return m.type === 'restriction'
      case ContractRuleStatus.Disallowed:
        return m.type === 'not_included'
      case ContractRuleStatus.ReferralRequired:
        return m.type === 'referral_tep'
      case ContractRuleStatus.AssessmentRequired:
        return m.type === 'assessment_required'
      case ContractRuleStatus.PaymentCommitmentDisallowed:
        return m.type === 'payment_commitment_invalid'
      case ContractRuleStatus.PaymentCommitmentAllowed:
        return m.type === 'payment_commitment_valid'
      case ContractRuleStatus.CompanyInsurance:
        return m.type === 'company_insurance'
      case ContractRuleStatus.DentalRestriction:
        return m.type === 'dental_tep'
      default:
        return false
    }
  })
}
